import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency';
import { isIosNativeOnly } from '@/utils/platform-check';
export async function requestTrackingPermission() {
  try {
    if (isIosNativeOnly()) {
      const result = await AppTrackingTransparency.getStatus();
      console.log('getStatus', result);
      if (result.status === 'notDetermined') {
        await AppTrackingTransparency.requestPermission();
      }
    }
  } catch (e) {
    console.log(e);
  }
}
